<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-catalogue
      code="choix-categorie"
      v-model="sasInscriptionTableauRegistre.typeDeCotisation"
      :live="liveSasInscriptionTableauRegistre(2314)"
      :code-filter="sas.typesCotisations"
      @eudo-updated="categorieChanged"
      :filter="filtreSpecifiquePourLe1erAvril2025()"
    >
    </opq-catalogue>
    <ressource v-show="estRetraite" code="declaration-retraite"></ressource>
    <opq-case
      :opq-if="estRetraite"
      code="declaration-retraite"
      v-model="sasInscriptionTableauRegistre.declarationDuMembreRetraite"
      :live="liveSasInscriptionTableauRegistre(2315)"
    ></opq-case>
    <ressource v-show="estExterieurQuebec" code="declaration-HQ"></ressource>
    <opq-catalogue
      :opq-if="estExterieurQuebec"
      code="type-membre-HQ"
      v-model="sasInscriptionTableauRegistre.situationDuMembreHorsQuebec"
      :live="liveSasInscriptionTableauRegistre(2317)"
    ></opq-catalogue>
    <opq-alert v-show="estExterieurQuebec" code="description-declaration-HQ"></opq-alert>
    <opq-date-picker
      :opq-if="estExterieurQuebec"
      :minYear="1990"
      code="date-debut-HQ"
      v-model="sasInscriptionTableauRegistre.dateDebutHorsQuebec"
      :live="liveSasInscriptionTableauRegistre(2318)"
      disabled
      ref="dateDebutHQ"
    >
    </opq-date-picker>
    <opq-date-picker
      :opq-if="estExterieurQuebec"
      code="date-fin-HQ"
      ref="dateFinHQ"
      v-model="sasInscriptionTableauRegistre.dateFinHorsQuebec"
      :live="liveSasInscriptionTableauRegistre(2319)"
      :minYear="new Date(sasInscriptionTableauRegistre.dateDebutHorsQuebec).getFullYear() + 1"
      :maxYear="new Date().getFullYear() + 10"
      :condition="
        (v) => {
          let nbJours = (new Date(v) - new Date(sasInscriptionTableauRegistre.dateDebutHorsQuebec)) / 1000 / 24 / 3600
          let premierAvrilAnneeEnCours = new Date(new Date().getFullYear(), 3, 1)
          return nbJours > 363 && new Date(v) >= premierAvrilAnneeEnCours
        }
      "
      conditionMessage="Un an minimum"
    >
    </opq-date-picker>
    <opq-case
      :opq-if="estExterieurQuebec"
      code="declaration-HQ"
      v-model="sasInscriptionTableauRegistre.declarationDuMembreHorsQuebec"
      :live="liveSasInscriptionTableauRegistre(2316)"
    ></opq-case>
    <ressource v-show="estCongeParental" code="declaration-cp"></ressource>
    <opq-date-picker
      :minYear="1990"
      :opq-if="estCongeParental"
      code="date-debut-CP"
      v-model="sasInscriptionTableauRegistre.dateDebutCongeParental"
      :live="liveSasInscriptionTableauRegistre(2321)"
      disabled
      ref="dateDebutCP"
    >
    </opq-date-picker>
    <opq-date-picker
      :opq-if="estCongeParental"
      code="date-fin-CP"
      ref="dateFinCP"
      v-model="sasInscriptionTableauRegistre.dateFinCongeParental"
      :live="liveSasInscriptionTableauRegistre(2322)"
      :minYear="new Date(sasInscriptionTableauRegistre.dateDebutCongeParental).getFullYear()"
      :maxYear="new Date(sasInscriptionTableauRegistre.dateDebutCongeParental).getFullYear() + 2"
      :condition="
        (v) => {
          let diff = (new Date(v) - new Date(sasInscriptionTableauRegistre.dateDebutCongeParental)) / 1000 / 24 / 3600
          let premierAvrilAnneeEnCours = new Date(new Date().getFullYear(), 3, 1)
          return diff > 0 && diff <= 365 && new Date(v) >= premierAvrilAnneeEnCours
        }
      "
      conditionMessage="Une journée minimum et un an maximum"
    >
    </opq-date-picker>
    <opq-case
      :opq-if="estCongeParental"
      code="declaration-CP"
      v-model="sasInscriptionTableauRegistre.declarationCongeParental"
      :live="liveSasInscriptionTableauRegistre(2320)"
    ></opq-case>
  </v-form>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import FormSimple from "@/mixins/FormSimple"
import { mapActions } from "vuex"
import { bus } from "@/plugins/bus"

export default {
  mixins: [CataloguesHelper, FormSimple],
  props: {
    sas: { type: Object },
  },

  methods: {
    ...mapActions(["fetchPanier"]),
    filtreSpecifiquePourLe1erAvril2025() {
      // DE-224/CAS-208 On filtre l'id 13 et 12: membre nouveau gradué 1/2eme année à partir du premier avril( inscription/réincription)
      // ou du renouvellement 2025 ( renouvellement)
      const shouldFilter =
        this.endpoint === "demande-renouvellement-psychologue" || new Date() >= new Date("2025-04-01")
      if (shouldFilter) {
        return (fd) => !fd.code.includes("13") && !fd.code.includes("12")
      }
      return
    },
    liveSasInscriptionTableauRegistre(cle) {
      return { endpoint: "sas-inscriptions-tableau-registre", cle: cle, fileId: this.sasInscriptionTableauRegistre.id }
    },
    estCategorie(codeCategorie) {
      return (
        this.getCatalogueCodeById(11124, this.sas.sasInscriptionAuTableauRegistre.typeDeCotisation) == codeCategorie
      )
    },
    estType(codeType) {
      return this.getCatalogueCodeById(2312, this.sas.sasInscriptionAuTableauRegistre.typeDInscription) == codeType
    },
    async categorieChanged() {
      if (this.estExterieurQuebec) {
        let dateReference = new Date()
        if (this.sas.congeParentalHorsQuebec.etaitHorsQuebec) {
          dateReference = new Date(this.sas.congeParentalHorsQuebec.dateDebutHorsQuebec)
        } else if (this.estRenouvellement) {
          dateReference = new Date(this.sas.dateDeRenouvellement)
        }
        await this.$refs.dateDebutHQ.setValue(dateReference)
        this.$refs.dateFinHQ.setYears()
        if (this.sas.congeParentalHorsQuebec.etaitHorsQuebec) {
          if (process.env.VUE_APP_DEBUG) {
            console.log(new Date(this.sas.congeParentalHorsQuebec.dateFinHorsQuebec))
          }
          await this.$refs.dateFinHQ.setValue(new Date(this.sas.congeParentalHorsQuebec.dateFinHorsQuebec))
        }
      }
      if (this.estCongeParental) {
        let dateReference = new Date()
        if (this.sas.congeParentalHorsQuebec.etaitCongeParental) {
          dateReference = new Date(this.sas.congeParentalHorsQuebec.dateDebutCongeParental)
        } else if (this.estRenouvellement) {
          dateReference = new Date(this.sas.dateDeRenouvellement)
        }
        await this.$refs.dateDebutCP.setValue(dateReference)
        this.$refs.dateFinCP.setYears()
        if (this.sas.congeParentalHorsQuebec.etaitCongeParental) {
          await this.$refs.dateFinCP.setValue(new Date(this.sas.congeParentalHorsQuebec.dateFinCongeParental))
        }
      }
      if (this.estRetraite) {
        if (this.sas.employeurs.length > 0) {
          bus.$emit("inactiverToutesLesCartesAffairesProfessionnelles")
        }
      }
      await this.fetchPanier(this.sas.id)
    },
  },

  computed: {
    sasInscriptionTableauRegistre() {
      return this.sas.sasInscriptionAuTableauRegistre
    },
    estExterieurQuebec() {
      return this.estCategorie(16)
    },
    estCongeParental() {
      return this.estCategorie(18)
    },
    estRetraite() {
      return this.estCategorie(15)
    },
    estRenouvellement() {
      return this.estType(2)
    },
  },
}
</script>

<style></style>
